<template>
  <div class="projects-container">
    <h1>Shrirang's Projects</h1>

    <section class="project-category">
      <h2>On-Going Projects</h2>
      <div class="project-cards">
        <a href="#" class="project-card">
          <i class="icon icon-pdf"></i>
          <div class="project-content">
            <h3>Placy - IIT Madras Placement/Internship Chatbot</h3>
            <p>
              As a member of the IIT Madras BS Degree Placement Council, I
              initiated the development of "Placy," a chatbot designed to
              address student queries related to placements and internships.
              This tool aims to reduce repetitive questions, providing students
              with quicker and more efficient responses.
            </p>
            <!-- <span class="project-date"
              >Tech Used:RAG Architecture, Gemini API, Langchain, Flask,
              Vue-CLI, postman, JIRA, SQLITE3
            </span> -->
            <span class="project-date">Status: On-going</span>
          </div>
        </a>

        <a href="#" class="project-card">
          <i class="icon icon-pdf"></i>
          <div class="project-content">
            <h3>Resume Evaluation Portal for IIT Madras</h3>
            <p>
              In response to the need for efficient resume evaluation, I've
              drafted IIT Madras-specific resume templates and am currently
              building a portal. This platform will allow students to create
              their resumes by filling out a form, evaluate their resume scores,
              and enable the Placement Council to batch evaluate resumes against
              job descriptions.
            </p>
            <!-- <span class="project-date"
              >Tech Used:Gemini API, FAISS Database, NVIDIA Nemo, HuggingFace,
              IndicTrans2, IndicASR</span
            > -->
            <span class="project-date">Status: On-going</span>
          </div>
        </a>
      </div>
    </section>
    <section class="project-category">
      <h2>GenAI Projects</h2>
      <div class="project-cards">
        <a
          href="https://youtu.be/QIej6KaTJwk?t=10261"
          target="_blank"
          class="project-card"
        >
          <i class="icon icon-pdf"></i>
          <div class="project-content">
            <h3>WonCourse - Learning Portal with GenAI Features</h3>
            <p>
              An academic project to build a learning portal with three
              GenAI-powered chatbots for lecture assistance, coding help, and
              administrative support. The project highlights the software
              development lifecycle, agile processes,GenAI integration and lot
              more...
            </p>
            <span class="project-date"
              >Tech Used:RAG Architecture, Gemini API, Langchain, Flask,
              Vue-CLI, postman, JIRA, SQLITE3
            </span>
            <span class="project-date">Completed: August 2024</span>
          </div>
        </a>

        <a
          href="https://github.com/shrirang20/krishichat-voice-assistance"
          target="_blank"
          class="project-card"
        >
          <i class="icon icon-pdf"></i>
          <div class="project-content">
            <h3>Krishi Voice Assistant</h3>
            <p>
              Empowering Indian farmers with a voice assistant supporting 26
              Indian languages. This chatbot provides agricultural information
              related to government schemes and assistance through voice
              communication, leveraging cutting-edge AI technology.
            </p>
            <span class="project-date"
              >Tech Used:Gemini API, FAISS Database, NVIDIA Nemo, HuggingFace,
              IndicTrans2, IndicASR</span
            >
            <span class="project-date">Completed: July 2024</span>
          </div>
        </a>

        <a
          href="https://www.kaggle.com/code/shrirangsapate/finetune-code-data"
          target="_blank"
          class="project-card"
        >
          <i class="icon icon-pdf"></i>
          <div class="project-content">
            <h3>Finetuning of a Frontend Generator Chatbot</h3>
            <p>
              Finetuned a Salesforce's CodeT5 Base model to generate frontend
              code (HTML, CSS, JavaScript). This project uses deep learning and
              focuses on enhancing code generation capabilities.
            </p>
            <span class="project-date"
              >Tech Used:Deep Learning, PyTorch, HuggingFace, HuggingFace
              Dataset, Flask</span
            >
            <span class="project-date">Completed: August 2024</span>
          </div>
        </a>

        <a
          href="https://chatbotwithshrirang.streamlit.app/"
          target="_blank"
          class="project-card"
        >
          <i class="icon icon-pdf"></i>
          <div class="project-content">
            <h3>Chat with me</h3>
            <p>
              Explore my academic, research, and professional background through
              this interactive resume built using RAG Architecture. Get insights
              into my skills, projects, and experiences in an engaging way.
            </p>
            <span class="project-date"
              >Tech Used: Gemini API, FAISS Vector Database, Langchain,
              Streamlit</span
            >
            <span class="project-date">Completed: April 2024</span>
          </div>
        </a>

        <a
          href="https://resume-ats.streamlit.app/"
          target="_blank"
          class="project-card"
        >
          <i class="icon icon-ai"></i>
          <div class="project-content">
            <h3>Application Tracking System (ATS)</h3>
            <p>
              Streamline your job application process by matching resumes with
              job descriptions. This AI-powered tool analyzes your resume
              against the job requirements, helping you optimize your chances of
              landing the job.
            </p>
            <span class="project-date"
              >Tech Used: Gemini API, Langchain, Streamlit</span
            >
            <span class="project-date">Completed: January 2024</span>
          </div>
        </a>

        <a
          href="https://bodyfuelmeter.streamlit.app/"
          target="_blank"
          class="project-card"
        >
          <i class="icon icon-health"></i>
          <div class="project-content">
            <h3>Health, Diet App</h3>
            <p>
              Manage your health effectively by tracking daily calorie intake
              and macro/micronutrient consumption. Input your TDEE, log meals,
              and see real-time feedback on your dietary habits. Note: The app
              is currently inactive due to Gemini Pro Vision API being taken
              down.
            </p>
            <span class="project-date"
              >Tech Used: Gemini API, Langchain, Streamlit</span
            >
            <span class="project-date">Completed: Febraury 2024</span>
          </div>
        </a>

        <a
          href="https://chatting-pdfs.streamlit.app/"
          target="_blank"
          class="project-card"
        >
          <i class="icon icon-pdf"></i>
          <div class="project-content">
            <h3>Pdf Chat</h3>
            <p>
              Upload any PDF and interact with its content through natural
              language queries. Ask questions directly related to the PDF's
              content. Currently inactive due to exhausted OpenAI API token.
            </p>
            <span class="project-date"
              >Tech Used: OpenAI API, AstraDB, Langchain, Streamlit</span
            >
            <span class="project-date">Completed: March 2024</span>
          </div>
        </a>
      </div>
    </section>

    <section class="project-category">
      <h2>Machine Learning</h2>
      <a
        href="https://arxiv.org/abs/2111.04003"
        target="_blank"
        class="project-cards"
      >
        <div class="project-card">
          <i class="icon icon-research"></i>
          <div class="project-content">
            <h3>Research Paper - Machine Learning</h3>
            <p>
              Predictive Model for Gross Community Production Rate of Coral
              Reefs Using Ensemble Learning Methodologies.
            </p>
          </div>
        </div>
      </a>
    </section>

    <section class="project-category">
      <h2>Full Stack Web Development</h2>
      <div class="project-cards">
        <a
          href="https://github.com/shrirang20/Grocery-Store-Flask-app"
          target="_blank"
          class="project-card"
        >
          <i class="icon icon-web"></i>
          <div class="project-content">
            <h3>Grocery Store Management Application</h3>
            <p>
              This project was part of the Application Development I course at
              IIT Madras. It involved building a web application from scratch,
              focused on managing a grocery store. The application includes two
              user roles: admin and user, allowing me to gain hands-on
              experience in end-to-end web development.
            </p>
            <span class="project-date">Tech Used:Flask, SQLITE3 </span>
            <span class="project-date">Completed: August 2023</span>
          </div>
        </a>
        <div class="project-card">
          <i class="icon icon-ticket"></i>
          <a
            href="https://github.com/shrirang20/Cinetick-Vue-App"
            target="_blank"
            class="project-content"
          >
            <h3>Ticket Booking Web App</h3>
            <p>
              As part of the Application Development II course at IIT Madras, I
              developed a Ticket Booking Web App. This project introduced me to
              new technologies like Vue.js. The app features two user roles:
              admin and user, providing a comprehensive platform for managing
              ticket bookings.
            </p>
            <span class="project-date"
              >Tech Used:Flask, Vue-CLI, postman, SQLITE3
            </span>
            <span class="project-date">Completed: December 2024</span>
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "ProjectsPage",
};
</script>

<style scoped>
.projects-container {
  max-width: 1500px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Roboto", Arial, sans-serif;
  background-color: #f9f9f9;
  color: #333;
  border-radius: 20px;
}

h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a73e8;
  text-align: center;
  margin-bottom: 40px;
}

.project-category {
  margin-bottom: 50px;
}

h2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #444;
  margin-bottom: 20px;
  border-bottom: 2px solid #e8eaed;
  padding-bottom: 10px;
}

.project-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.project-card {
  background-color: #fff;
  padding: 30px;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.project-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.icon {
  font-size: 2rem;
  margin-right: 15px;
  color: #1a73e8;
}

.project-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #222;
  margin: 0 0 10px 0;
}

.project-content p {
  font-size: 1rem;
  color: #666;
  margin: 0;
}

.project-card:hover .icon {
  color: #ff5722;
}

.project-card:hover h3 {
  color: #1a73e8;
}

a {
  text-decoration: None;
}

.project-content {
  position: relative;
}

.project-date {
  font-size: 0.85rem;
  color: #999;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
